import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { UserBehaviorService } from './user-events/user-behavior.service';

@Injectable({
  providedIn: 'root'
})
export class PortalV2Service implements OnInit {
  constructor(
    private http: HttpClient,
    private zone: NgZone,
    private userBehavior: UserBehaviorService
  ) {}

  async ngOnInit() {
    const user = await this.userBehavior.fromBehavior();
  }

  urlApiManagement = environment.urlStp;

  // Methods
  getFinancialStatements(salesDocumentsNumber: string) {
    const url = `${this.urlApiManagement}/api/v1/search-to-procure-v2/financial-statements/${salesDocumentsNumber}`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('getFinancialStatements()')));
  }

  getModalMovements(path: string, salesDocumentsNumber: string, get: any, params: any) {
    if (get) {
      const url = `${this.urlApiManagement}` + path + `${salesDocumentsNumber}`;
      return this.http.get(url, {}).pipe(catchError(this.handleError('getModalMovements()')));
    } else {
      const url = `${this.urlApiManagement}` + path;
      return this.http.post(url, params).pipe(catchError(this.handleError('getModalMovements()')));
    }
  }

  handleError(error: any) {
    if (!(error instanceof HttpErrorResponse)) {
      return (error = error.rejection);
    }

    this.zone.run(() => console.log('Message: ', error?.message, 'Error: ', error?.status));

    return console.error('Error from global error handler', error);
  }
}
